const english = {
	'active': { text: 'Active' },
	'inactive': { text: 'Inactive' },
	'pending': { text: 'Pending' },
	'verified': { text: 'Verified' },
	'unverified': { text: 'Unverified' },
	'confirmed': { text: 'Confirmed' },
	'ongoing': { text: 'Ongoing' },
	'ended': { text: 'Ended' },
	'completed': { text: 'Completed' },
	'deleted': { text: 'Deleted' },
	'admin': { text: 'NEMA Coordinator' },
	'state-head': { text: 'SEMA Coordinator' },
	'state-staff': { text: 'SEMA Staff' },
	'agency-head': { text: 'Partner Coordinator' },
	'agency-staff': { text: 'Partner Staff' },
	'yes': { text: 'Yes' },
	'no': { text: 'No' },

	'camp': { text: 'Camp' },
	'community': { text: 'Community' },

	'ngo': { text: 'NGO' },
	'ingo': { text: 'International NGO' },
	'faith-based': { text: 'Faith Based' },
	'government': { text: 'Government' },
	'cso': { text: 'CSO' },
	'philanthropist': { text: 'Philanthropist' },
	'mda': { text: 'MDA' },
	'other': { text: 'Other' }
}

export default (prop) => {
	return english[prop] ? english[prop].text : ''
}
